export default __webpack_public_path__ + "static/media/logo.5dd8ca8e.png";